// extracted by mini-css-extract-plugin
export default {"card":"_1pE7PVkYxmRfbn7tn40lY8","cardTitle":"_18G_xfYMVxtcf5n7oct8xo","titleActions":"D6GCsSja3QTa9OMlMslks","cardContent":"_5LgLNF2kU4yqPpog3BfsV"};